var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNewLocationIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0977,
    cy: 24,
    r: 24,
    fill: "#EFF2F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2946_24653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 14,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 18.1215V23.2915H31C32.1 23.2915 33 24.1915 33 25.2915V31.2915C33 32.3915 32.1 33.2915 31 33.2915H17C15.9 33.2915 15 32.3915 15 31.2915V21.2915C15 20.1915 15.9 19.2915 17 19.2915H21V18.1215C21 17.5915 21.21 17.0815 21.59 16.7015L23.29 15.0015C23.4768 14.8142 23.7305 14.709 23.995 14.709C24.2595 14.709 24.5132 14.8142 24.7 15.0015L26.41 16.7115C26.79 17.0815 27 17.5915 27 18.1215ZM17 31.2915H19V29.2915H17V31.2915ZM19 27.2915H17V25.2915H19V27.2915ZM17 23.2915H19V21.2915H17V23.2915ZM25 31.2915H23V29.2915H25V31.2915ZM23 27.2915H25V25.2915H23V27.2915ZM25 23.2915H23V21.2915H25V23.2915ZM23 19.2915H25V17.2915H23V19.2915ZM31 31.2915H29V29.2915H31V31.2915ZM29 27.2915H31V25.2915H29V27.2915Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 16.875H31.125V15.625C31.125 15.2812 30.8438 15 30.5 15C30.1562 15 29.875 15.2812 29.875 15.625V16.875H28.625C28.2812 16.875 28 17.1562 28 17.5C28 17.8438 28.2812 18.125 28.625 18.125H29.875V19.375C29.875 19.7188 30.1562 20 30.5 20C30.8438 20 31.125 19.7188 31.125 19.375V18.125H32.375C32.7188 18.125 33 17.8438 33 17.5C33 17.1562 32.7188 16.875 32.375 16.875Z",
    fill: "#DADADA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2946_24653)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#556EE6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewLocationIconSvg);
export default __webpack_public_path__ + "static/media/add-new-location-icon-svg.60e3f1cc.svg";
export { ForwardRef as ReactComponent };